var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$store.getters.isLoggedIn)?_c('div',{staticClass:"col-md-12 footer mt-5 pt-4"},[_c('p',[_vm._v("© "+_vm._s(_vm.year)+" S. Martinelli & Company "),_c('br',{staticClass:"mobile"}),_vm._v(" Image Library – All Rights Reserved.")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee131616","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 